import * as React from 'react';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import { ToolbarConfig } from '@tencent/workbench';
import AUTO_ADJUST_ICON from '@tencent/docs-design-resources/icon/desktop/svg/fit_width-height_outline_light_24.svg';
import i18n from '@i18next/i18n';

export const config = {
    id: ActionType.AUTO_ADJUST_SLIDE,
    icon: AUTO_ADJUST_ICON,
    content: i18n.t('适应窗口'),
};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: config.id,
        icon: <img src={config.icon} alt={''}/>,
        text: config.content,
        style: {
        },
        tooltip: config.content,
    },
];
